















































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    //放大图片
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    import ProductDetail from '@/store/entities/ProductDetailExpandDto'
    import skulist from '@/store/entities/skuList'
    import displayskudto from '@/store/entities/displayskudto'


    @Component({
        name: "editdetail"
    })
    export default class EditOrder extends AbpBase {
        productdetail: ProductDetail = new ProductDetail();
        skulists = Array<skulist>();
        displayskulist = Array<displayskudto>();
        addLoding = false;
        ishowtable = true;
        globalid: number;
        //headers: any = {
        //    "Authorization": "Bearer " + window.abp.auth.getToken(),
        //    ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
        //    "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        //};
        //ruleInline = {
        //    warehouseInfoId: [
        //        { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
        //    ],
        //    orderNumber: [
        //        { required: true, min: 6, max: 200, message: '虾皮订单编号不能为空，且长度必须大于6且小于200', trigger: 'blur' }
        //    ],
        //    shippingMethods: [
        //        { max: 100, message: '长度不能大于100', trigger: 'blur' }
        //    ],
        //    reMark: [
        //        { max: 500, message: '长度不能大于500', trigger: 'blur' }
        //    ]
        //};

     
        async returnBack() {
            this.backPage();
        }

        async getdata(id: any) {
            this.globalid = id;
            this.productdetail = await this.$store.dispatch({
                type: 'frontdistributionproduct/GetProductDetail',
                data: { ProductId: id }
            });
            if (this.productdetail.skuList.length > 0) {
                for (var i = 0; i < this.productdetail.skuList.length; i++) {
                    var one = this.productdetail.skuList[i].specificationCategoryId[0];
                    var two = null;
                    if (this.productdetail.skuList[i].specificationCategoryId.length > 1) {
                        two = this.productdetail.skuList[i].specificationCategoryId[1];
                    }
                    var onename = this.productdetail.specificationCategory.filter(c => c.id == one)[0].name;
                    var twoname = "";
                    if (two) {
                        var twoname = this.productdetail.specificationCategory.filter(c => c.id == two)[0].name;
                    }
                    this.displayskulist.push({ oneGG: onename, twoGG: twoname, skuId: this.productdetail.skuList[i].skuId, stock: this.productdetail.skuList[i].stock, price: this.productdetail.skuList[i].price, pvs:this.productdetail.skuList[i].pvs });
                }
            }
            else {
                this.ishowtable = false;
            }
        }

        async confirm() {
            if (this.productdetail.skuList.length > 0) {
                for (var i = 0; i < this.displayskulist.length; i++) {
                    var data = this.productdetail.skuList.filter(c => c.skuId == this.displayskulist[i].skuId)[0];
                    data.price = this.displayskulist[i].price;
                    data.stock = this.displayskulist[i].stock;
                    data.pvs = this.displayskulist[i].pvs;
                }
            }
            var _this = this;
            this.$Modal.confirm({
                title: "更新产品", content: "是否确认修改？", onOk: async () => {
                    _this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'backdistributionproduct/UpdateProduct',
                        data: { id: _this.globalid, detail: _this.productdetail }
                    })
                    setTimeout(() => {
                        _this.addLoding = false;
                        this.$Modal.confirm({
                            title: "温馨提示", content: "修改商品成功", onOk: async () => {
                                this.$router.push({ name: 'backdistributionproduct' });
                            }
                        });
                    }, 1000);

                }
            });
       
        }

        //show() {
        //    this.$Modal.confirm({
        //        title: "温馨提示", content: "修改商品成功", onOk: async () => {
        //            this.$router.push({ name: 'backdistributionproduct' });
        //        }
        //    });
        //}

        async created() {
            var id = abp.getQueryVariable("id");
            this.getdata(id);
        }
        async add(number) {
            (this.$refs.createform as any).validate(async (valid: boolean) => {
                if (valid) {
                    //if (!this.createrequest.pdfGuid || this.createrequest.pdfGuid.length < 1) {
                    //    this.$Message.error('请上传pdf。');
                    //    return;
                    //}
                    //if (this.createrequest.expressDelivery.length == 0) {
                    //    this.$Message.error('请添加物流单号。');
                    //    return;
                    //}
                    //if (this.createrequest.orderProductInfo.length == 0) {
                    //    this.$Message.error('请添加商品。');
                    //    return;
                    //}
                    //this.addLoding = true;
                    //await this.$store.dispatch({
                    //    type: 'fontorder/updateOrder',
                    //    data: this.createrequest
                    //}).finally(() => {
                    //    this.addLoding = false;
                    //});
                    //if (number == 1) {
                    //    this.$Message.success('修改成功。');
                    //}
                    //else {
                    //    this.$Message.success('订单信息补充成功。');
                    //}

                }
            })
        }

        columns = [
            {
                title: '一级规格名称',
                key: 'oneGG',
            },
            {
                title: '二级规格名称',
                key: 'twoGG',
            },
            {
                title: '价格（积分）',
                key: 'price',
                render: (h, { row, index }) => {
                    var _this = this;
                    var edit = [h('Input', {
                        props: {
                            value: row.price
                        },
                        on: {
                            'on-blur': (val) => {
                                _this.displayskulist[index].price = val.srcElement.value;
                            }
                            //input: (val) => {
                            //   // row.price = val;
                            //   _this.displayskulist[index].price = val;
                            //}
                        }
                    })];

                 
                    return edit;
                }
            },
            {
                title: '库存',
                key: 'stock',
                render: (h, { row, index }) => {
                    var _this = this;
                    var edit = [h('Input', {
                        props: {
                            value: row.stock
                        },
                        on: {
                            'on-blur': (val) => {
                                _this.displayskulist[index].stock = val.srcElement.value;
                            }
                        }
                    })];
                    return edit;
                }
            },
            {
                title: '货号',
                key: 'pvs',
                render: (h, { row, index }) => {
                    var _this = this;
                    var edit = [h('Input', {
                        props: {
                            value: row.pvs
                        },
                        on: {
                            'on-blur': (val) => {
                                _this.displayskulist[index].pvs = val.srcElement.value;
                            }
                        }
                    })];
                    return edit;
                }
            }
        ]
    }
